import { Component, Input, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-app-timer-button',
  templateUrl: './app-timer-button.component.html',
  styleUrls: ['./app-timer-button.component.scss']
})
export class AppTimerButtonComponent implements OnDestroy {
  private timerStartTime: number = 0;
  private time: number = 0;
  isTimeExceeded: boolean = false;
  private timeoutId: any;
  public timerText: string = '';
  public timerTextExceeded: string = '';

  @Input() set startTime(value: number) {
    this.timerStartTime = value;
    this.resetTimeout();
    this.startTickCount();
  }

  get startTime(): number {
    return this.timerStartTime;
  }

  @Input() thresholdTime: number = 0
  private resetTimeout() {
    this.isTimeExceeded = false;
    if (this.timeoutId) {
      clearInterval(this.timeoutId);
    }
  }
  constructor(private translateService: TranslateService) { 
    this.timeoutId  = null;
    this.translateService.get(['_Shared_App_Timer_BTN_Exceed_Info_Text_', '_Shared_App_Timer_BTN_Info_Text_']).subscribe((translation) => {
      this.timerText = translation['_Shared_App_Timer_BTN_Info_Text_'];
      this.timerTextExceeded = translation['_Shared_App_Timer_BTN_Exceed_Info_Text_'];
    })
  }

  ngOnDestroy(): void {
    this.timerStartTime = 0
    this.isTimeExceeded = false;
  }

  protected startTickCount() {
    const that = this;
    that.time = that.timerStartTime;

    that.timeoutId = setInterval(() => {
      ++that.time;

      if ((Math.floor((that.time / 60) % 60)) >= that.thresholdTime) {
        that.isTimeExceeded = true;

      }
    }, 1000); // Each seconds
  }
}
